import React from 'react';
import PropTypes from 'prop-types';
import SliderMUI from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Slider';

const Slider = ({
  className,
  onChange,
  value,
  min,
  max,
  step,
  marks,
  valueLabelDisplay,
}) => {
  return (
    <SliderMUI
      className={className}
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      step={step}
      marks={marks}
      valueLabelDisplay={valueLabelDisplay}
    />
  );
};

Slider.defaultProps = {
  className: '',
  min: undefined,
  max: undefined,
  step: undefined,
  marks: false,
  valueLabelDisplay: 'off',
};

Slider.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  marks: PropTypes.bool,
  valueLabelDisplay: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
};

export default Slider;
